import styles from './fourth.module.css';
import FullSize from '../../components/full-size';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState, useRef } from 'react';
import { getNextLevelUrl, isLevelAllowed, markLevelCompleted } from '../../helper';
import Button from '../../components/button';
import HintBox from '../../components/hint-box';
import clsx from 'clsx';

function Fourth() {
  const LEVEL = 4;
  const navigate = useNavigate();
  const [krusse, setKrusse] = useState('');
  const [hazze, setHazze] = useState('');
  const [henrik, setHenrik] = useState('');
  const [filip, setFilip] = useState('');
  const [shake, setShake] = useState(false);
  
  const filipRef = useRef<HTMLInputElement>(null);
  const henrikRef = useRef<HTMLInputElement>(null);
  const hazzeRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (!isLevelAllowed(LEVEL)) {
      navigate("/cheating");
    }
  }, [navigate])

  const allFilled = krusse && filip && henrik && hazze;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const combinedCode = krusse + filip + henrik + hazze;
    if (combinedCode === "3798" || combinedCode === "9898") {
      markLevelCompleted(LEVEL);
      navigate(getNextLevelUrl(LEVEL));
    } else {
      setShake(true);
    }
  };

  return (
    <FullSize bgColor="white">
      <form onSubmit={handleSubmit} className={clsx(styles.wrapper, { [styles.shake]: shake })}>
        <h1 className={styles.title}>Level 4</h1>
        <div className={styles.grid}>
          {/* Kvadrant 1 - Krusse */}
          <div className={`${styles.quadrant} ${styles.quadrantProfile}`}>
            <h2 className={styles.name}>Krusse</h2>
            <input
              type="number"
              value={krusse}
              onChange={(e) => {
                const newValue = e.target.value;
                setShake(false);
                setKrusse(newValue);
                if (newValue.length === 1 && krusse.length === 0) {
                  filipRef.current?.focus();
                }
              }}
              className={styles.input}
            />
            <img src="/profile.png" alt="" className={styles.profileImg} />
          </div>
          
          {/* Kvadrant 2 - Filip */}
          <div className={`${styles.quadrant} ${styles.quadrantProfile}`}>
            <h2 className={styles.name}>Filip</h2>
            <input
              ref={filipRef}
              type="number"
              maxLength={1}
              value={filip}
              onChange={(e) => {
                const newValue = e.target.value;
                setShake(false);
                setFilip(newValue);
                if (newValue.length === 1 && filip.length === 0) {
                  henrikRef.current?.focus();
                }
              }}
              className={styles.input}
            />
            <img src="/profile.png" alt="" className={styles.profileImg} />
          </div>
          
          {/* Kvadrant 3 - Henrik */}
          <div className={`${styles.quadrant} ${styles.quadrantProfile}`}>
            <h2 className={styles.name}>Henrik A</h2>
            <input
              ref={henrikRef}
              type="number"
              maxLength={1}
              value={henrik}
              onChange={(e) => {
                const newValue = e.target.value;
                setShake(false);
                setHenrik(newValue);
                if (newValue.length === 1 && henrik.length === 0) {
                  hazzeRef.current?.focus();
                }
              }}
              className={styles.input}
            />
            <img src="/profile.png" alt="" className={styles.profileImg} />
          </div>
          
          {/* Kvadrant 4 - Hazze */}
          <div className={`${styles.quadrant} ${styles.quadrantProfile}`}>
            <h2 className={styles.name}>Hazze</h2>
            <input
              ref={hazzeRef}
              type="number"
              maxLength={1}
              value={hazze}
              onChange={(e) => {
                setShake(false);
                setHazze(e.target.value);
              }}
              className={styles.input}
            />
            <img src="/profile.png" alt="" className={styles.profileImg} />
          </div>
        </div>
        
        <div className={styles.submit}>
          <Button type="submit" disabled={!allFilled}>Skicka</Button>
        </div>
      </form>
      <HintBox hintText="Kan det ha något med vår eminenta hemsida att göra?" />
    </FullSize>
  );
}

export default Fourth;
